module.exports = __webpack_public_path__ + "img/7.b6be3b86.svg";